import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UtilityService } from '../../../services/utility.service';
import { RegionListResponse, RegionResponse, UtilityResponse } from '../../../interfaces/responses/models';
import { RegionService } from '../../../services/region.service';
import { AuthService } from '../../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { AccountChangeRequestComponent } from '../account-change-request/account-change-request.component';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css'],
})
export class AccountComponent implements OnInit {
  accountForm: FormGroup;
  states: RegionResponse[] = [];
  utilities: UtilityResponse[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private utilityService: UtilityService,
    private regionService: RegionService,
    private authService: AuthService,
    public dialog: MatDialog,
  ) {
    this.accountForm = this.fb.group({
      id: [{ value: '', disabled: true }],
      phone_number: [{ value: '', disabled: true }],
      name: [{ value: '', disabled: true }],
      last_name: [{ value: '', disabled: true }],
      locality: [{ value: '', disabled: true }],
      state_name: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      meter_number: [{ value: '', disabled: true }],
      connection_number: [{ value: '', disabled: true }],
      utility_name: [{ value: '', disabled: true }],
      pin_code: [{ value: '', disabled: true }],
      customer_id: [{ value: '', disabled: true }],
    });
  }

  ngOnInit() {
    this.authService.getBasicCurrentUserDetails().subscribe((data) => {
      console.log("Date from basic details: ", data)
      this.accountForm.patchValue(data);
    });
  }

  onChangeRequest(): void {
    console.log('Requesting change');
    this.dialog.open(AccountChangeRequestComponent)
  }

  backToMarket(): void {
    this.router.navigate(['/']);
  }

  get userId() {
    return this.accountForm.get('id');
  }

  get meterNumber() {
    return this.accountForm.get('meter_number');
  }
  get name() {
    return this.accountForm.get('name');
  }
  get last_name() {
    return this.accountForm.get('last_name');
  }
  get connection_number() {
    return this.accountForm.get('connection_number');
  }
  get state() {
    return this.accountForm.get('state_name');
  }
  get utility_name() {
    return this.accountForm.get('utility_name');
  }
  get pin_code() {
    return this.accountForm.get('pin_code');
  }
  get locality() {
    return this.accountForm.get('locality');
  }
  get email() {
    return this.accountForm.get('email');
  }
}
